{
    "cancel": "Cancel",
    "confirm": "Confirm",
    "save": "Save",
    "delete": "Delete",
    "edit": "Edit",
    "back": "Back",
    "next": "Next",
    "previous": "Previous",
    "search": "Search",
    "loading": "Loading...",
    "submit": "Submit",
    "close": "Close",
    "yes": "Yes",
    "no": "No",
    "login": "Sign in",
    "logout": "Sign out",
    "register": "Sign up",
    "email": "Email",
    "password": "Password",
    "phone": "Phone number",
    "settings": "Settings",
    "profile": "Profile",
    "dashboard": "Dashboard",
    "actions": "Actions",
    "status": "Status",
    "createdAt": "Created at",
    "updatedAt": "Updated at",
    "cookie": {
        "banner": {
            "title": "We use cookies",
            "message": "We use cookies to enhance your experience and analyze traffic.",
            "accept": "Accept all",
            "reject": "Essential only",
            "manage": "Manage preferences",
            "learnMore": "Learn more"
        }
    }
}
